module.exports = __webpack_public_path__ + "hinted-Montserrat-Thin.fca444b0f1084fc57da6.ttf";


//////////////////
// WEBPACK FOOTER
// C:/progetti java/ispra-infoaria/ispra-infoaria/ispra-infoaria-wui/infoaria-wui-client/src/assets/custom-styles/fonts/hinted-Montserrat-Thin.ttf
// module id = ../../../../../src/assets/custom-styles/fonts/hinted-Montserrat-Thin.ttf
// module chunks = 1